<template>
  <div id="app">
    <div id="nav">
      <router-link to="/">Home</router-link> |
      <router-link to="/custom-model">CustomModel</router-link> |
      <router-link to="/lights-shadows">LightsShadows</router-link> |
      <router-link to="/camera-mechanics">CameraMechanics</router-link> |
    </div>
    <router-view />
  </div>
</template>

<script>
export default {
  metaInfo: {
    title: "HiTest",
    meta: [
      {
        vmid: "keywords",
        name: "keywords",
        content: "babylonjs",
      },

      {
        vmid: "description",
        name: "description",
        content: "이 페이지는 babylonjs의 기능을 학습한 기록입니다.",
      },
    ],
  },
};
</script>

<style lang="scss">
#app {
  font-family: Pretendard;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

#nav {
  padding: 30px;

  a {
    font-weight: bold;
    color: #2c3e50;

    &.router-link-exact-active {
      color: #42b983;
    }
  }
}
</style>
